import { InfoOutlined } from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';

export const InfoOutlinedIcon = (props: SvgIconProps) => {
  return <InfoOutlined {...props} />;
};
